<template>
  <div class="job-detail-history-row" :class="isAuthor ? 'my-event' : ''">
    <div class="job-detail-history-block">
      <div class="job-detail-history-data">
        <div class="job-detail-history-data-profile">
          <p>{{ history.FirstName }} {{ history.LastName }}</p>
          &nbsp;/&nbsp;
          <span>{{ userRole }}</span>
        </div>

        <div class="job-detail-history-data-text">
          <p>{{ history.EventDescription }}</p>
        </div>
      </div>

      <div class="job-detail-history-when">
        {{ history.CreationDateTime | formatStartDeadline }}
      </div>

      <div class="job-detail-history-status">
        <span>{{ history.JobType }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  props: {
    history: {
      type: Object,
      default: () => ({}),
    },
    accountTypes: {
      type: Array,
      default: () => Array(),
    },
  },
  computed: {
    isAuthor() {
      return this.history.UserNameRole === this.$store.state.user.UserId;
    },
    userRole() {
      const userObj = this.accountTypes.find((item) => item.ID == this.history.UserRole);
      return history.UserRole === 0 ? 'Deleted user'
        : (userObj ? userObj.AccountTypeName : 'Administrator');
    },
  },
});
</script>

<style lang="scss">
.job-detail-history-row {
  &.my-event {
    background: rgba(0, 172, 230, .1);
  }
}
</style>
